import { dismissNotification } from '../actions/notificationBarActions';
import { getNotificationBarCallback } from '../callbacksMap/notificationBarCallbacks';
import { CustomNotificationBarCallbackReason } from '../schema/NotificationInterfaces';
import { lazyDismissNotification } from 'owa-notification-bar';
import { orchestrator } from 'satcheljs';

orchestrator(dismissNotification, actionMessage => {
    let { actionName } = actionMessage;

    lazyDismissNotification.import().then(dismissAction => {
        // the default behavior of the dismissAction is to cancel whatever callbacks existed on the notfication, including the autodismissed, and
        // remove the notification. We want to override that and make sure the callback still gets called with a custom dismiss reason
        let callback = getNotificationBarCallback();
        if (callback) {
            callback(CustomNotificationBarCallbackReason.ForceDismissedFromCode);

            // if there was no callback defined for this action, means we've already dismissed it. Attempting to dismiss it a second time
            // will fail and log an error, so we only call this if the callback was defined
            dismissAction(actionName);
        }
    });
});
